<template>
  <div>
    <vk-button @click="show = true" type="primary">
      <vk-icon icon="search"></vk-icon>
    </vk-button>
    <vk-offcanvas overlay :show.sync="show">
      <vk-offcanvas-close @click="show = false"></vk-offcanvas-close>
      <form @submit.prevent="submitQuery">
        <h1>Search</h1>
        <div class="uk-margin-bottom">
          <label for="includeInactive">
            <input
              class="uk-checkbox"
              type="checkbox"
              id="includeInactive"
              v-model="includeInactive"
            > Include Inactive Members
          </label>
        </div>
        <label for="firstName">First Name</label>
        <input id="firstName" class="uk-input" type="text" v-model="fName">
        <label for="lastName">Last Name</label>
        <input id="lastName" class="uk-input" type="text" v-model="lName">
        <label for="bookNumber">Book Number</label>
        <input id="bookNumber" class="uk-input" type="text" v-model="bookNum">
        <div class="advancedWrap">
          <input type="checkbox" id="advancedSearch" class="uk-animation-toggle">
          <label for="advancedSearch">
            <a>Advanced Search</a>
            <span></span>
          </label>
          <div class="toggle">
            <br>
            <label class="uk-text-bold" for="classifications">Classifications</label>
            <div
              v-for="(classification,index) in this.options.classifications"
              v-bind:key="'class'+index"
            >
              <label>
                <input
                  class="uk-checkbox"
                  type="checkbox"
                  v-model="classifications"
                  :value="classification.classification"
                  v-bind:id="'classitem'+index"
                >
                {{classification.classification}}
              </label>
            </div>
            <label class="uk-margin-top uk-text-bold" for="certifications">Certifications</label>
            <div
              v-for="(certification,index) in this.options.certifications"
              v-bind:key="'cert'+index"
            >
              <label>
                <input
                  class="uk-checkbox"
                  type="checkbox"
                  v-model="certifications"
                  :value="certification.certification"
                  v-bind:id="'certitem'+index"
                >
                {{certification.certification}}
              </label>
            </div>
          </div>
        </div>
        <div class="uk-button-group">
          <vk-button class="uk-width-1-2" v-on:click="handleRefresh">Reset</vk-button>&nbsp;&nbsp;
          <input
            class="uk-button uk-button-primary uk-width-1-2"
            type="submit"
            value="Submit"
          >
        </div>
      </form>
    </vk-offcanvas>
  </div>
</template>

<script>
import MembersApi from "@/utils/api/members";
import OptionsApi from "@/utils/api/options";

export default {
  name: "DashboardSearch",
  data() {
    var data;
    if (sessionStorage.searchParams) {
      data = JSON.parse(sessionStorage.searchParams);
    } else {
      data = {
        options: {},
        fName: "",
        lName: "",
        bookNum: "",
        includeInactive: false,
        classifications: [],
        certifications: [],
        show: false
      };
    }

    return data;
  },
  created() {
    OptionsApi.getAllOptions(this.$cookie.get("iwl_apiToken"))
      .then(res => {
        this.options = res;
        this.submitQuery();
      })
      .catch(err => console.log(err));

  },
  methods: {
    handleRefresh() {
      this.includeInactive = false;
      this.fName = "";
      this.lName = "";
      this.classifications = [];
      this.certifications = [];
      this.$emit("refresh");
      this.show = false;
      delete sessionStorage.searchParams;
    },
    submitQuery() {
      this.show = false;

      sessionStorage.searchParams = JSON.stringify({
        options: {},
        fName: this.fName,
        lName: this.lName,
        bookNum: this.bookNum,
        includeInactive: this.includeInactive,
        classifications: this.classifications,
        certifications: this.certifications,
        show: this.show
      });
      this.$emit("params");
    }
  }
};
</script>

<style scoped>
input,
textarea {
  margin-bottom: 20px;
}
input[type="checkbox"],
input[type="submit"] {
  margin-bottom: 0px;
}
.uk-button-group {
  width: 100%;
  margin-top: 20px;
}
.toggle {
  display: none;
}
#advancedSearch {
  width: 100%;
  position: absolute;
  top: 0px;
  opacity: 0;
  height: 30px;
  cursor: pointer;
  margin: 0px;
}
#advancedSearch:checked ~ .toggle {
  display: block;
}
#advancedSearch:hover + label a {
  color: #0f6ecd;
}
.advancedWrap {
  position: relative;
}
.advancedWrap label span {
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 8px 7px 0 7px;
  border-color: #1e87f0 transparent transparent transparent;
  position: relative;
  top: 14px;
  left: 5px;
}
#advancedSearch:checked + label span {
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 0 7px 8px 7px;
  border-color: transparent transparent #1e87f0 transparent;
  position: relative;
  top: -14px;
  left: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/admin_dashboard_search.vue